import React from "react";
import {
  infoBoxStyle,
  infoBoxDescriptionStyle,
  infoBoxTitleStyle,
  infoBoxActionContainerStyle,
  infoBoxMainContainerStyle,
  infoBoxVariants,
} from "./info-box.css";
import { Text } from "@vagastec/ensemble-core";

export function InfoBox({
  variant = "",
  illustration,
  title,
  description,
  actionContent,
}) {
  return (
    <div className={`${infoBoxStyle} ${infoBoxVariants[variant]}`}>
      {illustration}
      <div className={infoBoxMainContainerStyle}>
        <Text size="sm" weight={600} as="p" className={infoBoxTitleStyle}>
          {title}
        </Text>
        <Text size="sm" as="p" className={infoBoxDescriptionStyle}>
          {description}
        </Text>
      </div>
      <div className={infoBoxActionContainerStyle}>{actionContent}</div>
    </div>
  );
}
